// zh_CN.js
import React from "react";
const ms_MY = {
    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
//components
    "XiaDanTiXing":"Peringatan Pemesanan",
    "NH_GDDBH_":"Halo, pesanan ini mengandungi produk dengan 'harga anggaran', perlu menunggu pengesahan harga dari pelanggan sebelum membuat pembayaran, adakah anda pasti mahu membuat pesanan?",
    "QueRenXiaDan":"Pasti Pemesanan",
    "WoZaiKanKan":"Saya lihat lagi",
    "XSQBDZ": "Tunjukkan semua alamat",
//ChatRoom
    "ZBZCBQFH": "Tidak menyokong emoji buat masa ini",
    "FaSongLianJie": "Hantar pautan",
    "YiChangXiaoXi": "Mesej tidak normal",
    "QingShuRu": "Sila masukkan",
    "FaSong": "Hantar",
//DateSelector
    "DQSJXYKSSJ": "Masa semasa kurang daripada masa mula",
    "DQSJCGJSSJ": "Masa semasa melebihi masa tamat",
    "QuXiao": "Batal",
    "NianYueRi": "Tahun bulan hari",
    "ShiFen": "Jam minit",
    "QueDing": "Pasti",
    "Nian": "tahun",
    "Yue": "bulan",
    "Ri": "hari",
    "Shi": "jam",
    "Fen": "minit",
//goods-list-card
    "Qi": "mula",
//goods-promotion
    "1GeCuXiao": "1 promosi",
    "ChaKanZengPin": "Lihat hadiah",
    "JHDJSHS_1T": "Masa tinggal sehingga akhir aktiviti: {d}hari{h}jam{m}minit{s}saat",
    "YHGZ_ZPBKD": "Peraturan diskaun: Hadiah tidak boleh diperoleh secara叠加",
    "YHGZ_AZZGM": "Peraturan diskaun:享受优惠 mengikut jumlah pembelian akhir",
    "GuanBi": "Tutup",
//group-filtrate
    "QuanBu": "Semua",
    "ZWXGSJ": "Tiada data berkaitan",
    "ZuiDiJia": "Harga terendah",
    "ZuiGaoJia": "Harga tertinggi",
    "LeiXing": "Jenis",
    "PinPai": "Jenama",
    "BiaoQian": "Tag",
    "JiaGeQuJian": "Julat harga",
    "SPMC_GG_BH_": "Nama produk / Spesifikasi / No. / Huruf pertama",
    "ZuHeShaiXuan": "Penapis gabungan",
    "ChongZhi_CanShu": "Set semula",
//image-upload
    "ZDKSC1ZTP": "Maksimum boleh muat naik {num} gambar",
    "ZYXSCTP": "Hanya dibenarkan muat naik gambar",
    "SCTPDXBYXC": "Saiz gambar yang dimuat naik tidak dibenarkan melebihi {size}",
    "QBYCFSCTP_": "Jangan muat naik gambar yang sama, atau pastikan nama gambar unik",
    "ShangChuanChengGong": "Muat naik berjaya",
    "ZDKSC1Z": "Maksimum boleh muat naik {num} helai",
//keyboard
    "CCSLZDXZ": "Melebihi had maksimum jumlah",
    "QiDingLiang": "Jumlah minimum pesanan",
    "ShouQi": "Lipat",
    "ShanChu": "Padam",
//MultiPicker
    "FanHui": "Kembali",
//order-cart
    "Dai": "dai",
    "YiQuXiao": "Telah dibatalkan",
    "ZengPin": "Hadiah",
    "1Zhong": "{num} jenis",
    "1Jian": "1 helai",
    "HeJi": "Jumlah",
    "DaiFu": "Belum dibayar",
//order-promotion
    "_DDM1YZ1J_": "[Pesanan memenuhi {targetPrice} yuan, hadiah {presentNum} helai]",
    "_DDM1YLJ1Y_": "[Pesanan memenuhi {targetPrice} yuan, diskaun {price} yuan terus]",
    "_DDM1YLX1Z_": "[Pesanan memenuhi {targetPrice} yuan,享受 {discount} diskaun]",
    "DingDanCuXiao": "Promosi pesanan",
//page-ad
    "DLCKJG": "Log masuk untuk melihat harga",
//page-floating
    "DianPuZhuYe": "Laman utama kedai",
    "GouWuChe": "Kereta belanja",
    "ZaiXianKeFu": "Pelayanan pelanggan dalam talian",
    "GeRenZhongXin": "Pusat peribadi",
    "LianXiDianHua": "Nombor telefon",
    "FanHuiDingBu": "Kembali ke atas",
//page-null
    "ZBDYML": "Laman tidak ditemui",
    "KNWZCW_HZY": "Mungkin alamat laman salah, atau laman telah dipadam",
    "FanHuiShangJi": "Kembali ke peringkat atas",
    "FanHuiShouYe": "Kembali ke laman utama",
//product-edit
    "SPQDBNWK": "Senarai produk tidak boleh kosong",
    "WoZhiDaoLe": "Saya faham",
    "SFQRSCSP": "Adakah anda pasti mahu memadam produk",
    "QueRen": "Pasti",
    "ZYXSRSZBQB": "Hanya dibenarkan memasukkan nombor dan tidak melebihi 2 tempat perpuluhan",
    "ShangPinDanJia": "Harga seunit produk",
    "YSPYJ": "Harga asal produk",
    "QSRZDJG": "Sila masukkan harga tertentu",
    "ShuLiang": "Jumlah",
    "DanWei": "Unit",
    "DanJia": "Harga seunit",
    "BeiZhu": "Nota",
    "YiChuShangPin": "Keluarkan produk",
    "XiuGai": "Kemaskini",
//yunshl
    "TPSLCCYXSZ": "Jumlah gambar melebihi nilai yang dibenarkan!",
    "WJBDDY5M_QC": "Fail tidak boleh lebih besar daripada 5m, sila pilih semula",
    "TPSCWC": "Pemuatan gambar selesai",
//BusinessFilter
    "_DGSLM1JZ1J": "[Jumlah pesanan memenuhi {num} helai, hadiah {presentNum} helai]",
    "_M1JLXMJ1Y_": "[Memenuhi {num} helai,享受 setiap helai {price} yuan]",
    "_DHJJZ1Y_": "[Harga pesanan diturunkan kepada {price} yuan]",
    "_M1JLXMJ1Z_": "[Memenuhi {num} helai,享受 setiap helai {discount} diskaun]",
    "_YDHJD1Z_": "[Harga pesanan asal dengan {discount} diskaun]",
    "YuJi": "Jangkaan",
    "MMYDDR": "Hari DD bulan MM",
    "KaiShiFaHuo": "Mula penghantaran",
    "_DGSLM1Z1_": "[Jumlah pesanan memenuhi {num}, hadiah {presentNum}]",
    "_M1LXM1Y_": "[Memenuhi {num},享受 setiap {price} yuan]",
    "_M1LXM1Z_": "[Memenuhi {num},享受 setiap {discount} diskaun]",
    "DaiQueRen": "Menunggu pengesahan",
    "DaiFaHuo": "Menunggu penghantaran",
    "DaiShouHuo": "Menunggu penerimaan",
    "YiWanCheng": "Selesai",
    "DaiFuKuan": "Menunggu pembayaran",
    "YiFuKuan": "Telah dibayar",
    "YiZuoFei": "Telah dimusnahkan",
    "DaiShenHe": "Menunggu审核",
    "DaiHeXiao": "Menunggu verifikasi",
    "YiHeXiao": "Telah diverifikasi",
    "XianXiaZhiFu": "Pembayaran luar talian",
    "ZhiNengDaoZhangShiBie": "Pemindahan luar talian (pengenalan pembayaran pintar)",
    "WeiXinZhiFu": "Pembayaran WeChat",
    "KqZhiFu": "Pembayaran Kuaiqian (menyokong WeChat/Alipay)",
    "ZFBZF": "Pembayaran Alipay",
    "YuEZhiFu": "Pembayaran baki",
    "HuoDaoFuKuan": "Pembayaran pada penerimaan barang",
    "DaiTuiHuo": "Menunggu pengembalian",
    "DaiTuiKuan": "Menunggu pembayaran balik",
    "ChuangJianDingDan": "Cipta pesanan",
    "BianJiDingDan": "Kemaskini pesanan",
    "TiJiaoDingDan": "Hantar pesanan",
    "DingDanShenHe": "审核 pesanan",
    "CaiWuShenHe": "审核 kewangan",
    "BoHui": "Tolak",
    "TianJiaShouKuan": "Tambah penerimaan",
    "ZaiXianZhiFu": "Pembayaran dalam talian (menyokong WeChat/Alipay/Pay京东/UnionPay)",
    "YinLianZhiFu": "Pembayaran UnionPay",
    "MercadoPagoZhiFu": "Pembayaran MercadoPago",
    "ShouKuanShenHe": "审核 penerimaan",
    "ShouKuanZuoFei": "Membatalkan penerimaan",
    "ChuKu": "Keluar gudang",
    "ChuKuShenHe": "审核 keluar gudang",
    "FaHuo": "Hantar",
    "TianJiaWuLiu": "Tambah logistik",
    "XiuGaiWuLiu": "Kemaskini logistik",
    "ChuKuZuoFei": "Membatalkan keluar gudang",
    "ShouHuo": "Terima",
    "DingDanHeZhun": "Pengesahan pesanan",
    "QuXiaoDingDan": "Batal pesanan",
    "CJTHD": "Cipta borang pengembalian",
    "DaYin": "Cetak",
    "DaoChu": "Eksport",
    "DingDanWanCheng": "Pesanan selesai ",
    "QiangZhiWanCheng": "Selesaikan secara paksa",
    "DingDanZuoFei": "Membatalkan pesanan",
    "MaiZeng": "Beli dan dapatkan hadiah",
    "ZhiJiang": "Penurunan terus",
    "DaZhe": "Diskon",
    "YuShou": "Prapemesanan",
    "DingDanManZeng": "Pesanan memenuhi hadiah",
    "DingDanManJian": "Pesanan memenuhi diskaun",
    "DingDanManZhe": "Pesanan memenuhi diskaun peratusan",
    "XinRenQuan": "Kupon baru",
    "ManJianQuan": "Kupon diskaun apabila mencapai jumlah",
    "ShangPinQuan": "Kupon produk",
    "DaiJieSuan": "Menunggu penyelesaian",
    "YiJieSuan": "Telah diselesaikan",
    "QuanBuShangPin": "Semua produk",
    "TuiJianShangPin": "Produk disyorkan",
    "XinPin": "Produk baru",
    "ReXiaoShangPin": "Produk popular",
    "ChangYongShangPin": "Produk kerap digunakan",
//BusinessUtil
    "DaiShouKuan": "Menunggu penerimaan",
    "BuFenShouKuan": "Sebahagian penerimaan",
    "YiShouKuan": "Telah diterima",
    "BXYFP": "Tidak memerlukan bil",
    "ZZSPTFP": "Bil cukai nilai tambah biasa",
    "ZZSZYFP": "Bil cukai nilai tambah khas",
    "QiTaFaPiao": "Bil lain-lain",
    "XianXia": "Luar talian",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Wang simpanan awal",
    "XianXiaZhuangZhang": "Pemindahan luar talian",
    "XianShangZhiFu": "Pembayaran dalam talian",
    "YCKZF": "Pembayaran dengan wang simpanan awal",
    "DaiTiJiao": "Menunggu penghantaran",
    "KuaiDi": "Kurier",
    "SongHuoShangMen": "Hantaran ke rumah",
    "ShangMenZiQu": "Ambil sendiri di tempat",
    "WuLiuHuoYun": "Logistik pengangkutan",
    "QiTa": "Lain-lain",
//check-util
    "QSRBXY6WDM": "Sila masukkan kata laluan tidak kurang daripada 6 aksara",
    "QSRBDY20WDM": "Sila masukkan kata laluan tidak lebih daripada 20 aksara",
    "MMGSCW": "Format kata laluan salah",
//common-utils
    "SJCW_QLXKF": "Ralat data, sila hubungi pembantu pelanggan",
    "ZBZCQD": "Tidak menyokong tandatangan buat masa ini",
    "HuJiao": "Hubungi",
    "DLZHBCZ": "Akaun log masuk tidak wujud",
    "QLXGLYKT": "Sila hubungi pentadbir untuk membuka",
    "GQYZHBJY": "Akaun syarikat ini telah dinyatakan tidak sah",
    "QLXYSDH": "Sila hubungi 云上订货",
    "GQYZHSYQJS_": "Tempoh percubaan akaun syarikat ini telah tamat",
    "GQYZHYGQL_": "Akaun syarikat ini telah luput",
    "XYXFCNSY": "Perlu menambah tempoh untuk menggunakan",
    "GQYBCZCZH": "Syarikat ini tidak mempunyai akaun ini",
    "NDDHZHYBQY": "Akaun pesanan anda telah dinyatakan tidak sah oleh syarikat 1, tidak boleh log masuk. Sila hubungi pentadbir",
    "NYBSQY1DHZ": "Anda bukan lagi pelanggan kerjasama syarikat 1, tidak boleh log masuk. Sila hubungi pentadbir",
    "NDDPYBTY_B": "Kedai anda telah dinyatakan tidak aktif, tidak boleh log masuk. Sila hubungi pentadbir",
    "GZHWKTDSZB": "Akaun ini tidak mempunyai fungsi灯饰专版. Sila hubungi pentadbir",
    "WXSQYZYGQ": "Pengesahan lesen WeChat telah luput",
    "WXSQSB": "Gagal pengesahan WeChat",
    "WXSQSB_CWX": "Gagal pengesahan WeChat, maklumat ralat",
    "DengLuGuoQi": "Log masuk luput",
    "DLGQ_QCXDL": "Log masuk luput, sila log masuk semula",
//data-constant
    "ShangJia": "Dimasukkan ke platform",
    "YiXiaJia": "Telah dikeluarkan dari platform",
    "YiJinYong": "Telah dinyatakan tidak sah",
    "YiQiYong": "Telah diaktifkan",
    "YiTingYong": "Telah dinonaktifkan",
    "KeHuZhuCe": "Pendaftaran pelanggan",
    "XinZengDaoRu": "Tambah import",
    "DDDSH": "Menunggu审核 pesanan",
    "DCWSH": "Menunggu审核 kewangan",
    "DaiChuKu": "Menunggu keluar gudang",
    "DCK_BF_": "Menunggu keluar gudang (sebahagian)",
    "DFH_BF_": "Menunggu penghantaran (sebahagian)",
    "DSH_BF_": "Menunggu penerimaan (sebahagian)",
    "DSK_BF_": "Menunggu penerimaan (sebahagian)",
    "WTHSQ": "Tiada permintaan pengembalian",
    "THDSH": "Pengembalian menunggu审核",
    "THCLZ": "Pengembalian sedang diproses",
    "THYWC": "Pengembalian telah selesai",
    "DYDHD": "Cetak borang pesanan",
    "DYFHD": "Cetak borang penghantaran",
    "DCDHD": "Eksport borang pesanan",
    "DCFHDWE_P": "Eksport borang penghantaran sebagai fail Excel/PDF",
    "TuiDanZuoFei": "Membatalkan borang pengembalian",
    "DTHSH": "Menunggu审核 pengembalian",
    "DaiRuKu": "Menunggu masuk gudang",
    "DRK_BF_": "Menunggu masuk gudang (sebahagian)",
    "DFK_BF_": "Menunggu pembayaran (sebahagian)",
    "ChuangJianTuiDan": "Cipta borang pengembalian",
    "BianJiTuiDan": "Kemaskini borang pengembalian",
    "TiJiaoTuiDan": "Hantar borang pengembalian",
    "TuiHuoShenHe": "审核 pengembalian",
    "RuKu": "Masuk gudang",
    "RuKuShenHe": "审核 masuk gudang",
    "RuKuZuoFei": "Membatalkan masuk gudang",
    "TianJiaFuKuan": "Tambah pembayaran",
    "FuKuanZuoFei": "Membatalkan pembayaran",
    "FuKuanShenHe": "审核 pembayaran",
    "TuiDanWanCheng": "Borang pengembalian selesai",
    "QiTaChuKu": "Keluar gudang lain-lain",
    "XiaoShouChuKu": "Keluar gudang jualan",
    "PanKuiChuKu": "Keluar gudang kerugian inventori",
    "DiaoBoChuKu": "Keluar gudang pemindahan",
    "CaiGouTuiHuo": "Pengembalian pembelian",
    "TuiHuoRuKu": "Masuk gudang pengembalian",
    "CaiGouRuKu": "Masuk gudang pembelian",
    "QiTaRuKu": "Masuk gudang lain-lain",
    "PanYingRuKu": "Masuk gudang keuntungan inventori",
    "DiaoBoRuKu": "Masuk gudang pemindahan",
    "CJCGD": "Cipta borang pembelian",
    "BJCGD": "Kemaskini borang pembelian",
    "TJCGD": "Hantar borang pembelian",
    "CGDZF": "Membatalkan borang pembelian",
    "CGDWC": "Borang pembelian selesai",
    "CGTHZF": "Membatalkan pengembalian pembelian",
    "CGTHWC": "Pengembalian pembelian selesai",
    "THDDY": "Cetak borang pengembalian",
    "THDDC": "Eksport borang pengembalian",
    "CKDDY": "Cetak borang keluar gudang",
    "CKDDC": "Eksport borang keluar gudang",
    "GLDZH": "Akaun pihak pengurusan",
    "DHDZH": "Akaun pihak pesanan",
    "ShenHeTongGuo": "审核 diluluskan",
    "SHBTG": "审核 tidak diluluskan",
    "WuXuFaPiao": "Tidak memerlukan bil",
    "DaiKeXiaDan": "Pemesanan bagi pelanggan",
    "ZiZhuXiaDan": "Pemesanan sendiri",
    "PCShangCheng": "Mall PC",
    "APPShangCheng": "Mall APP",
    "TVShangCheng": "Mall TV",
    "WeiXinShangCheng": "Mall WeChat",
    "ShouJiShangCheng": "Mall telefon bimbit",
    "ADDXSMLTC": "Komisen mengikut keuntungan margin jualan pesanan",
    "ADDXSSRTC": "Komisen mengikut pendapatan jualan pesanan",
    "AKHSSYG": "Mengikut pekerja yang mempunyai pelanggan",
    "AnZhiDanRen": "Mengikut pembuat dokumen",
    "ATHJEBLKCT": "Deduksi jumlah komisen mengikut nisbah jumlah pengembalian",
    "DDYTHBJXTC": "Tiada komisen jika pesanan mempunyai pengembalian",
    "DaiDaKuan": "Menunggu pembayaran",
    "WeiKaiShi": "Belum bermula",
    "JinXingZhong": "Sedang berlangsung",
    "YiGuoQi": "Telah luput",
//Utils.js
    "YouHuo": "Terdapat stok",
    "WuHuo": "Tiada stok",
    "Yi": "100 juta",
    "QianWan": "10 juta",
    "BaiWan": "Juta",
    "Wan": "10 ribu",
    "Sheng1Tian": "Baki 1 hari",
    "Sheng1XiaoShi": "Baki 1 jam",
    "Miao": "saat",
    "1Miao": "1 saat",
    "GangGang": "Baru sahaja",
    "1FenZhongQian": "1 minit yang lalu",
    "1XiaoShiQian": "1 jam yang lalu",
    "1TianQian": "1 hari yang lalu",
    "1GeYueQian": "1 bulan yang lalu",
    "1NianQian": "1 tahun yang lalu",
    "WeiZhiLeiXing": "Jenis tidak diketahui",
//WechatUtil
    "YYGBCDSP_K": "Terdapat produk yang bagus, cepat lihat",
    "ZanWeiSheZhi": "Belum ditetapkan",
//app
    "HQWXSQXX": "Dapatkan maklumat lesen WeChat",
//flexible
    "JGJYYDMBQ": "Akan menetapkan nisbah pembesaran berdasarkan tag meta yang sedia ada",
//index
    "NLJZZ": "Memuatkan dengan usaha",
//routes
    "ShangPinMingXi": "Butiran produk",
    "ShangPinLeiBie": "Kategori produk",
    "QXZFPNR": "Sila pilih kandungan bil",
    "QXZFPLX": "Sila pilih jenis bil",
    "QTXFPTT": "Sila isi tajuk bil",
    "FaPiaoTaiTou": "Tajuk bil",
    "NSRSBH": "No. pengenalan pembayar cukai",
    "FaPiaoNeiRong": "Kandungan bil",
    "FaPiaoXinXi": "Maklumat bil",
    "KaiJuFaPiao": "Cetak bil",
    "FaPiaoLeiXing": "Jenis bil",
    "Han": "termasuk",
    "WeiHan": "tidak termasuk",
    "Shui": "cukai",
    "QSRFPTT": "Sila masukkan tajuk bil",
    "QSRNSRSBH": "Sila masukkan no. pengenalan pembayar cukai",
//routes
//cart-bill
    "YiManZu_Man": "Telah memenuhi [mencapai",
    "ZaiGou": "Beli lagi",
    "YMZ_DHJJZ": "Telah memenuhi [harga pesanan diturunkan kepada",
    "JianJiangZhi": "helai diturunkan kepada",
    "YMZ_YDHJD": "Telah memenuhi [harga pesanan asal dengan",
    "JianMeiJian": "helai setiap helai",
    "SYTCSLW0_WFJRGWC": "Jumlah paket baki ialah 0, tidak boleh dimasukkan ke dalam kereta belanja",
    "QingXuanXeShangPin": "Sila pilih produk!",
    "GSPYXJ": "Produk ini telah dikeluarkan dari platform!",
    "ZJ2TN": "Dalam tempoh 2 hari terakhir",
    "QDQCXJSP": "Pasti ingin membersihkan produk yang dikeluarkan dari platform?",
    "QingChuChengGong": "Pembersihan berjaya",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Produk paket tidak boleh dimasukkan ke kereta belanja, sila batalkan produk paket sebelum memindahkan ke kereta belanja!",
    "SPSLBN": "Jumlah produk tidak boleh",
    "TaoCanHan": "Paket termasuk",
    "TaoCan": "Paket",
    "QHDSL": "Sila semak jumlah",
    "SPSLBNDY": "Jumlah produk tidak boleh kurang daripada",
    "XianDingLiang": "Had pesanan",
    "YiRuShouCang": "Masukkan ke koleksi",
    "QuanXuan": "Pilih semua",
    "JianZeng": "helai hadiah",
    "JianLiXiang_Man": "helai享受 [mencapai",
    "Yuan_": "yuan]",
    "Zhe_": "diskon]",
    "KCBZ_WFJRGWC": "Stok tidak mencukupi, tidak boleh dimasukkan ke kereta belanja",
    "XDJEDYDY": "Jumlah pesanan lebih besar atau sama dengan",
    "WYXJHYSXDSP": "Tiada produk yang dikeluarkan dari platform atau tidak sah!",
    "DYQDL": "Kurang daripada jumlah minimum pesanan",
    "ZSPG1J": "{count} jenis produk, jumlah {number} helai",
    "WanCheng": "Selesai",
    "BianJi": "Kemaskini",
    "You": "ada",
    "ZSPBFHYQ_W": "jenis produk tidak memenuhi syarat, tidak dipilih, klik untuk melihat alamat lalai",
    "SPSLBNGY": "Jumlah produk tidak boleh lebih daripada",
    "JXDJ_CKXYGBFHYQSP": "Klik terus, lihat produk berikutnya yang tidak memenuhi syarat",
    "XiaDan": "Pesan",
    "JianJiang": "helai diturunkan",
    "QRYCSP": "Pasti ingin mengeluarkan produk?",
    "QXZXDSP": "Sila pilih produk untuk pesanan",
    "KCBZ_QCXXZ": "Stok tidak mencukupi, sila pilih semula!",
    "KuCun": "Stok",
    "YCKXD": "yuan untuk membuat pesanan",
    "QDSCSP": "Pasti ingin menyimpan produk?",
    "ShouCangChengGong": "Penyimpanan berjaya",
    "GYXDL": "Lebih daripada had pesanan",
    "LiSheng": "Jimat terus",
    "GWCHSKD_QGYGB": "Kereta belanja masih kosong, pergi menjelajah!",
    "QuGuangGuang": "Pergi menjelajah",
    "QCXJSP": "Bersihkan produk yang dikeluarkan dari platform",
    "ZongE": "Jumlah jumlah",
    "YouHui": "Diskaun",
//cart-list
    "QXZJHRQ": "Sila pilih tarikh penghantaran",
    "FuJiaFeiYong": "Yuran tambahan",
    "ZhongShangPin_Gong": "jenis produk, jumlah",
    "PeiSongShiJian": "Masa penghantaran",
    "QXZPSSJ": "Sila pilih masa penghantaran",
    "DingDanJinE": "Jumlah pesanan",
    "SCFJ_ZD4Z": "Muat naik lampiran, maksimum {num} helai, setiap helai tidak melebihi {size}",
    "KeYongShangPin": "Produk yang boleh digunakan",
    "ShiYongShuoMing": "Arahan penggunaan",
    "YouXiaoQi": "Tempoh hayat",
    "Man": "mencapai",
    "BZZBZCTSFH": "Nota tidak menyokong simbol khas buat masa ini",
    "QingXuanZe": "Sila pilih",
    "KaiPiaoXuJia": "Memerlukan tambahan untuk cetak bil",
    "PeiSongFangShi": "Cara penghantaran",
    "ShangPinZongJia": "Jumlah harga produk",
    "YouHuiQuan": "Kupon diskaun",
    "ZhangKeXan": "helai boleh dipilih",
    "DDJEWMZ": "Jumlah pesanan tidak memenuhi",
    "WDYHQ": "Kupon diskaun saya",
    "KYYHQ": "Kupon diskaun yang boleh digunakan",
    "YuanKeYong": "yuan boleh digunakan",
    "ChaKanDingDan": "Lihat pesanan",
    "ShangPinHanShui": "Produk termasuk cukai",
    "SPWHS": "Produk tidak termasuk cukai",
    "GeDian": "peratus",
    "QueRenDingDan": "Pasti pesanan",
    "XZSHDZ": "Tambah alamat penerimaan",
    "ShangPinQingDan": "Senarai produk",
    "WKYYHQ": "Tiada kupon diskaun yang boleh digunakan",
    "HuChi": "Saling eksklusif",
    "DaiJinQuan": "Kupon wang tunai",
    "YunFei": "Yuran penghantaran",
    "ShuiFei": "Yuran cukai",
    "WKYYY": "Sebab tidak boleh digunakan",
    "YHQYGQ": "Kupon diskaun telah luput",
    "WDYHQSYSJ": "Belum sampai masa penggunaan kupon diskaun",
    "ZDSPJEWMZ": "Jumlah produk tertentu tidak memenuhi",
    "BKYYHQ": "Kupon diskaun yang tidak boleh digunakan",
    "RMBJE":"Jumlah yuan",
//cart-presale-order
    "QXZPSFS": "Sila pilih cara penghantaran",
    "1ZSP_G": "1 jenis produk, jumlah",
    "YSSP_YJ": "Produk prapemesanan, jangkaan",
    "JiaoHuoRiQi": "Tarikh penghantaran",
    "GMJLY": "Mesej kepada penjual",
//scan-to-cart
    "ZhengZaiChuLi...": "Sedang diproses...",
    "FSCSP": "Bukan produk商城",
    "ZZCLTXM": "Sedang memproses kod bar...",
    "SPTJCG": "Produk berjaya ditambah",
    "QSTXM": "Sila scan kod bar",
    "SFSCDQSP": "Adakah anda ingin memadam produk semasa?",
    "BQ_ZBDXGSP": "Maaf, tidak menjumpai produk berkaitan",
    "XuanZeDanWei": "Pilih unit",
    "JRGWC": "Masukkan ke kereta belanja",
    "QXXZDJRSP": "Sila pilih produk yang akan dimasukkan terlebih dahulu",
    "ZhengZaiChuLi": "Sedang diproses",
    "JRGWCCG": "Berjaya masukkan ke kereta belanja",
    "ZanWuShangPin": "Tiada produk",
//earn-brokerage-share
    "XTYJBNFZSP": "Sistem telah menyalin pautan produk untuk anda!",
    "NKYHDDYDYJ": "Anda boleh mendapatkan komisen yang sepadan. Komisen boleh dilihat di \"我的",
    "LiChaKan": "di sini",
    "WeiXinHaoYou": "Rakan WeChat",
    "ErWeiMa": "Kod QR",
    "CASBEWM": "Tekan dan kenal pasti kod QR",
    "FZSB_QCXFZ": "Salinan gagal, sila salin semula!",
    "TWEWM": "Kod QR grafik",
    "BCDXC": "Simpan ke album",
    "CATPBCDXC": "Tekan gambar untuk menyimpan ke album",
    "FuZhiLianJie": "Salin pautan",
    "FXZYJ": "Kongsi untuk mendapatkan komisen",
    "YJZGKZQYJ": "Jangkaan komisen maksimum yang boleh diperoleh",
//goods-share
    "FXSPGLSKH": "Kongsi produk kepada pelanggan runcit",
    "FXHJSCNZSD": "Selepas berkongsi, akan dihasilkan商城 telefon bimbit eksklusif anda, anda boleh menetapkan harga produk dalam商城, isi butiran hubungan anda, menarik pembeli datang membeli.",
    "WSCDQJG_ND": "Harga semasa商城 telefon bimbit: harga pesanan anda ×",
    "DaiSheZhi": "Menunggu tetapan",
    "PengYouQuan": "Muka surat rakan",
    "GGFXSZ": "Tukar tetapan kongsi",
//wechat-login
    "QXSRZH": "Sila masukkan akaun terlebih dahulu",
    "MMGSCW_6_20W": "Format kata laluan salah (6-20 aksara huruf atau nombor)",
    "BDYYZH": "Hubungkan akaun sedia ada",
    "WXKJDL": "Log masuk pantas WeChat",
    "BangDingZhangHao": "Hubungkan akaun",
    "YYZH_QDL": "Mempunyai akaun, pergi log masuk",
    "ZCXZH": "Daftar akaun baru",
    "HuanYingNi": "Selamat datang",
    "ZH_SJHM": "Akaun/Nombor telefon",
    "MiMa": "Kata laluan",
    "QDLHCZ": "Sila log masuk sebelum membuat operasi",
//add-to-cart
    "KCBZ_BNTJG": "Stok tidak mencukupi, tidak boleh menambah lagi",
//combined-pay-online
    "ZhiFuChengGong": "Pembayaran berjaya!",
    "ZFSB_QCXCS": "Pembayaran gagal, sila cuba semula!",
//
    "QXXZGG": "Sila pilih spesifikasi terlebih dahulu",
    "SXGGX": "Spesifikasi yang dipilih memerlukan",
    "GMSLXYQDL_": "Jumlah pembelian kurang daripada jumlah minimum pesanan, sila beli semula!",
    "GMSLDYXDL_": "Jumlah pembelian lebih daripada had pesanan, sila beli semula!",
    "ShangPinBianHao": "No. produk",
    "QiDing": "Jumlah minimum",
    "SXGGDGSLBK": "Jumlah pesanan spesifikasi yang dipilih tidak boleh melebihi",
    "KCBZ_BNTJ": "Stok tidak mencukupi, tidak boleh ditambah",
    "QXXZSP": "Sila pilih produk terlebih dahulu",
    "SLBNW0": "Jumlah tidak boleh 0",
    "QXZGG": "Sila pilih spesifikasi",
    "LiJiYuDing": "Tempah sekarang",
//nav
    "ShouYe": "Laman utama",
    "ShangPin": "Produk",
    "DingDan": "Pesanan",
    "WoDe": "Saya",
//pay-online
    "ZhiFuQuXiao": "Pembayaran dibatalkan",
//account-log
    "ShangPinYongJin": "Komisen produk",
    "YaoQingJiangLi": "Hadiah jemputan",
    "TiXian": "Penarikan",
    "TiXianBoHui": "Penarikan ditolak",
    "ZhuanWeiYuE": "Tukar kepada baki",
    "Jin7Tian": "7 hari lepas",
    "Jin30Tian": "30 hari lepas",
    "ShouZhiMingXi": "Butiran pendapatan dan perbelanjaan",
    "ZanWuShuJu": "Tiada data",
//client-statistics
    "WoDeKeHu": "Pelanggan saya",
    "WoDeYaoQing": "Jemputan saya",
//distribution-home
    "LeiJiKeHu": "Jumlah pelanggan terkumpul",
    "LeiJiDingDan": "Jumlah pesanan terkumpul",
    "YaoQingHaoYou": "Jemput rakan",
    "LeiJiYaoQing": "Jumlah jemputan terkumpul",
    "LJSY_Y_": "Jumlah pendapatan (yuan)",
    "BHDJS": "Termasuk yang menunggu penyelesaian",
        "J7TSY_Y_": "Pendapatan 7 hari lepas (yuan)",
    "J7TXZKH_R_": "Pelanggan baharu 7 hari lepas (orang)",
    "KTXYJ": "Komisen boleh ditarik",
    "XYJYO": "Perlu usaha lagi",
    "ChangJianWenTi": "Soalan lazim",
    "Q_ZMYJX_TG": "Q: Bagaimana cara \"promosikan untuk mendapatkan wang\"",
    "A_FXDPND_Z_": "A: Kongsi pautan halaman dengan ikon \"wang\" di kedai, tarik perhatian rakan untuk klik, rakan mendaftar (hubungan pelanggan ditetapkan sebagai terikat semasa pendaftaran) atau membuat pesanan (hubungan pelanggan ditetapkan sebagai terikat semasa pesanan) dan membeli produk dengan ikon \"wang\" di kedai tersebut, semuanya akan dikira sebagai pendapatan \"promosikan untuk mendapatkan wang\" mengikut kaedah pengiraan tertentu.",
    "Q_RHJS_TGZ": "Q: Bagaimana mengira pendapatan \"promosikan untuk mendapatkan wang\"?",
    "A_MGD_Z_TBD": "A: Setiap produk dengan ikon \"wang\" mempunyai nisbah komisen tertentu, produk tanpa tanda ini tidak mengambil bahagian dalam \"promosikan untuk mendapatkan wang\". Selepas rakan membuat pembayaran berjaya melalui pautan kongsi anda, komisen akan dikira secara berasingan mengikut nisbah komisen setiap produk dalam pesanan (komisen tidak mengambil bahagian dalam promosi ialah 0), akhirnya dijumlahkan sebagai pendapatan komisen untuk pesanan tersebut. Dalam pengiraan pendapatan, yuran penghantaran, pembayaran balik, diskaun apabila mencapai jumlah dll. akan ditolak, berdasarkan harga jualan akhir.",
    "Q_TGZQ_DSY": "Q: Bilakah pendapatan \"promosikan untuk mendapatkan wang\" masuk akun?",
    "A_HYTGNDFX": "A: Selepas rakan membuat pembayaran berjaya melalui pautan kongsi anda, anda boleh melihat promosi ini dalam pesanan promosi pusat jualan, statusnya ialah menunggu penyelesaian. Selepas pelanggan mengesahkan penerimaan, transaksi pesanan selesai diselesaikan, pendapatan ini akan自动 masuk akun peribadi anda, boleh ditarik bila-bila masa.",
    "Q_LJKH_LJY": "Q: Tiada avatar dan nama dalam senarai pelanggan terkumpul dan jemputan terkumpul?",
    "A_WXYQZYGZ": "A: WeChat memerlukan hanya mengikuti akaun perkhidmatan disahkan untuk mendapatkan avatar dan nama. Pelanggan kedai yang merupakan akaun perkhidmatan disahkan mengikuti akaun rasmi kedai; yang bukan akaun perkhidmatan disahkan mengikuti akaun rasmi \"Yunshang Order\" dan klik mana-mana halaman butiran produk kedai untuk mendapatkan avatar dan nama.",
    "Q_WSMWASSG": "Q: Mengapa saya berkongsi mengikut peraturan di atas tetapi tidak mendapatkan pendapatan promosi?",
    "A_1_HYKNBW": "A: 1. Rakan anda mungkin tidak membina hubungan pelanggan dengan anda (rakan klik pautan jurujual lain untuk mendaftar atau membuat pesanan) 2. Jika rakan anda buka pautan kongsi anda di luar persekitaran WeChat (seperti pelayar lalai telefon), jika pelayar tidak menghidupkan cookie, tidak akan dapat merekod hubungan pelanggan, iaitu tidak dapat merekod pesanan promosi 3. Jika semua perkara di atas tiada masalah tetapi masih tiada rekod pesanan promosi, sila hubungi kakitangan kerja.",
//
    "XiaoShouZhongXin": "Pusat Jualan",
//generalize-goods
    "SPMC_GG_BH": "Nama Produk / Spesifikasi / No.",
    "YuJiZhuan": "Jangkaan untung",
//invitation-home
    "YaoQingKa": "Kad Jemputan",
    "YNYQJR_TGY": "Jemput anda bersama-sama menyertai, promosikan untuk menang hadiah",
    "DJBCDXC": "Klik untuk simpan ke album",
    "JYQKFSGHY_": "Hantar kad jemputan kepada rakan, promosikan kedai untuk mendapatkan balasan",
//join-home
    "HuanYingJiaRu": "Selamat menyertai",
    "YQNCW": "Jemput anda menjadi",
    "LiJiJiaRu": "Sertai segera",
//order-statistics
    "YuJiYongJin": "Jangkaan komisen",
    "YongJin": "Komisen",
    "YuJiJiangLi": "Jangkaan hadiah",
    "JiangLi": "Hadiah",
    "SPTGDD": "Pesanan Promosi Produk",
    "YQJLDD": "Pesanan Hadiah Jemputan",
//performance-statistics
    "YeJiTongJi": "Statistik Prestasi",
    "LJKH_R_": "Jumlah pelanggan terkumpul (orang)",
    "SPYJ_Y_": "Komisen Produk (yuan)",
    "HanDaiJieSuan": "Termasuk menunggu penyelesaian",
    "XGMCJS": "Terjemahan istilah berkaitan",
    "KeHu": "Pelanggan",
    "HFXYBDLKHG": "Pembeli atau jurujual yang terikat hubungan pelanggan dengan jurujual",
    "YaoQing": "Jemputan",
    "FXYCGYQDXJ": "Jurujual bawahan yang berjaya dijemput oleh jurujual",
    "FXYTJKHGMH": "Komisen yang boleh diperoleh oleh jurujual selepas menjana pelanggan membeli",
    "XJFXYTGSPH": "Hadiah yang diperoleh oleh jurujual atas selepas jurujual bawahan mempromosikan produk",
//posters-promoting
    "NiCheng": "Nama panggilan",
    "HaiBaoTuiGuang": "Promosi Poster",
    "JHBFSGHY_T": "Hantar poster kepada rakan, promosikan kedai untuk mendapatkan balasan",
//settlement-home
    "JieSuanZhongXin": "Pusat Penyelesaian",
    "KTXJE": "Jumlah boleh ditarik",
    "TiXianJiLu": "Rekod Penarikan",
//withdraw-account
    "KHRXMBNWK": "Nama pemilik akaun tidak boleh kosong!",
    "KHHBNWK": "Bank pembuka akaun tidak boleh kosong!",
    "YHKHBNWK": "No. kad bank tidak boleh kosong!",
    "SFZTPBNWK": "Gambar IC tidak boleh kosong!",
    "YHKTPBNWK": "Gambar kad bank tidak boleh kosong!",
    "BaoCunChengGong": "Simpan berjaya!",
    "SCSFZ": "Muat naik IC",
    "SCYHK": "Muat naik kad bank",
    "BaoCun": "Simpan",
    "TiXianZhangHu": "Akaun Penarikan",
    "TS_QTXZSXX": "Nota: Sila isi maklumat sebenar, boleh ditarik selepas审核 diluluskan",
    "KHRXM": "Nama pemilik akaun",
    "KaiHuHang": "Bank pembuka akaun",
    "YinhangKaHao": "No. kad bank",
    "QSRZSXM": "Sila masukkan nama sebenar",
    "QSRKHHMC": "Sila masukkan nama bank pembuka akaun",
    "QSRYHKH": "Sila masukkan no. kad bank",
//withdraw-deposit
    "QXSZTXZH": "Sila tetapkan akaun penarikan terlebih dahulu",
    "QuSheZhi": "Pergi tetapkan",
    "JEXY10Y_BKT": "Jumlah kurang daripada 10 yuan, tidak boleh ditarik!",
    "JECGKTXJE": "Jumlah melebihi jumlah boleh ditarik!",
    "CGDRKTXSX_": "Melebihi had penarikan harian, had penarikan harian ialah 20000 yuan!",
    "QueDingJiang": "Pasti akan",
    "ZhuanDaoYuE": "tukar kepada baki?",
    "1_JEDY10YSB": "1. Jumlah kurang daripada 10 yuan tidak boleh ditarik;",
    "2_BCTXDZSJ": "2. Masa penarikan masuk akun kali ini ialah dalam 5 hari bekerja selepas permohonan penarikan berjaya, had penarikan harian ialah 20000 yuan;",
    "3_GBSRWHSS": "3. Pendapatan ini ialah pendapatan selepas cukai, sila sendiri pergi ke jabatan cukai berkaitan untuk membuat pengisytiharan dan bayaran cukai pendapatan peribadi!",
    "4_ZDYEKYYS": "4. Tukar kepada baki boleh digunakan untuk membeli di mall;",
    "TXSQCG_QDD": "Permohonan penarikan berjaya, sila tunggu审核",
    "JEDYKTXJE_": "Jumlah lebih daripada jumlah boleh ditarik, tidak boleh tukar kepada baki!",
    "ZZYECG_QDG": "Tukar baki berjaya, sila lihat di pusat peribadi!",
    "BenCiTiXian": "Penarikan kali ini",
    "ZhuangDaoYuE": "Tukar kepada baki",
    "TiXianDao": "Tarik ke",
    "JEW0BKZZYE": "Jumlah 0 tidak boleh tukar kepada baki!",
    "DRTXSX2WY": "Had penarikan harian 20 ribu yuan",
    "QuanBuTiXian": "Tarik semua",
    "QueRenTiXian": "Pasti penarikan",
//goods-filter-tab
    "ZuiChangGouMai": "Paling kerap dibeli",
    "MoRenPaiXu": "Susunan lalai",
    "ZongHe": "Gabungan",
    "FenLei": "Kategori",
    "XiaoLiangYouXian": "Utama jumlah jualan",
    "XiaoLiang": "Jumlah jualan",
    "JiaGe": "Harga",
    "ShaiXuan": "Penapis",
    "ZuiJinGouMai": "Terbaru dibeli",
    "CuXiaoYouXian": "Utama promosi",
    "QuanBuFenLei": "Semua kategori",
    "ZhiKanCuXiao": "Hanya lihat promosi",
    "XuanZeFenLei": "Pilih kategori",
    "QXZFL": "Sila pilih kategori",
//goods-list-default
    "ZWXGSP": "Tiada produk berkaitan",
//goods-brand-list
    "PinPaiHui": "Kumpulan Jenama",
//goods-classify-filter
    "TuiJianFenLei": "Kategori disyorkan",
    "ShangPinFenLei": "Kategori Produk",
    "GengDuo": "Lebih banyak",
//goods-detail
    "DLZHBSDQQY": "Akaun log masuk bukan akaun pelanggan syarikat semasa",
    "GXNHQ": "Tahniah anda mendapatkan",
    "SZWSCJGH_C": "Selepas menetapkan harga mall telefon bimbit, baru boleh berkongsi",
    "JHDJSHS_": "Masa tinggal sehingga akhir aktiviti",
    "DLHKFX": "Log masuk untuk berkongsi",
    "ZZHQXX_QSH": "Sedang mendapatkan maklumat, sila cuba semula kemudian",
    "Zhang": "helai",
    "Tian": "hari",
    "QXZGGZQPD": "Sila pilih spesifikasi sebelum memasang lampu!",
    "Yuan": "yuan",
    "XS_F_M": "jam/minit/saat",
//integral
    "WoDeJiFen": "Poin Saya",
    "DaBaiLe": "Mengalahkan",
    "JiFen": "Poin",
    "DeHuiYuan": "ahli",
    "ZhuanJiFen": "Dapatkan poin",
    "JiFenMingXi": "Butiran Poin",
    "HuanLiPin": "Tukar hadiah",
    "CKGDHL": "Lihat lebih banyak hadiah baik",
    "ChaDingDan": "Semak pesanan",
//integral-convert
    "DHSLBNCG": "Jumlah penukaran tidak boleh melebihi",
    "DuiHuanShuLiang": "Jumlah penukaran",
    "SuoXuJiFen": "Poin diperlukan",
//integral-detail
    "LiPinXiangQing": "Butiran Hadiah",
    "WoYaoDuiHuan": "Saya mahu menukar",
    "ShengYu": "Baki",
    "TuWenXiangQing": "Butiran grafik dan teks",
    "YiDuiWan": "Telah habis ditukar",
//integral-filter
    "FenLeiShaiXuan": "Penapis Kategori",
    "JiFenShaiXuan": "Penapis Poin",
//integral-flow
    "JiFenShouRu": "Pendapatan Poin",
    "JiFenZhiChu": "Perbelanjaan Poin",
//integral-logistics
    "DingDanGenZong": "Lacak Pesanan",
    "WuLiuGongSi": "Syarikat Logistik",
    "WuLiuDanHao": "No. resi logistik",
//integral-order
    "DingDanLieBiao": "Senarai Pesanan",
    "YiFaHuo": "Telah dihantar",
    "JiFenDingDan": "Pesanan Poin",
    "ChaKanWuLiu": "Lihat logistik",
//integral-order-create
    "LPSLBZ_QCX": "Jumlah hadiah tidak mencukupi, sila bayar semula",
    "JiFenBuZu": "Poin tidak mencukupi",
    "ZhiFuXinXi": "Maklumat Pembayaran",
    "JiXuGuangGuang": "Terus menjelajah",
    "QTXSHXX": "Sila isi maklumat penerimaan",
    "DuiHuanChengGong": "Penukaran berjaya",
    "LPDHQR": "Pengesahan penukaran hadiah",
    "SCCKJ": "Harga rujukan pasaran",
    "LiJiZhiFu": "Bayar segera",
//integral-order-detail
    "DingDanXiangQing": "Butiran Pesanan",
    "DingDanZhuangTai": "Status Pesanan",
    "DingDanBianHao": "No. Pesanan",
    "DuiHuanShiJian": "Masa Penukaran",
    "ShouHuoXinXi": "Maklumat Penerimaan",
    "HuaFeiJiFen": "Poin digunakan",
//integral-rule
    "QDZJF": "Tandatangan untuk mendapatkan poin",
    "XDZJF": "Pesan untuk mendapatkan poin",
    "DDWCHKHDYD": "Selepas pesanan selesai, boleh mendapatkan dengan jumlah pesanan*",
    "1_MRQD_JL": "1. Tandatangan setiap hari, hadiah",
    "2_LXQD3T_EW": "2. Tandatangan berterusan selama 3 hari, hadiah tambahan",
    "3_LXQD7T_EW": "3. Tandatangan berterusan selama 7 hari, hadiah tambahan",
    "BeiDeJiFen": "kali poin",
    "DLZJF": "Log masuk untuk mendapatkan poin",
    "MeiRiDengLu": "Log masuk setiap hari",
    "SC_JL": "mall, hadiah",
//integral-rule-detail
    "GuiZe": "Peraturan",
//integral-sign
    "QianDaoYouLi": "Tandatangan dengan hadiah",
    "QianDaoGuiZe": "Peraturan Tandatangan",
    "YLXQD": "Telah tandatangan berterusan",
    "QDCG_NYJLX": "Tandatangan berjaya, anda telah tandatangan berterusan",
    "QDCG_BCHD": "Tandatangan berjaya, kali ini mendapatkan",
    "QSRBZ": "Sila masukkan nota",
    "DingDanZengPin": "Hadiah Pesanan",
    "GuiGeBianHao": "No. Spesifikasi",
    "GuiGe": "Spesifikasi",
//combined-pay
    "CDDWXFK": "Pesanan ini tidak memerlukan pembayaran",
    "YHYEBZ": "Baki pengguna tidak mencukupi!",
    "ZFJEBNW0": "Jumlah pembayaran tidak boleh 0!",
    "ZFJEBNDYDD": "Jumlah pembayaran tidak boleh lebih daripada jumlah belum dibayar pesanan",
    "DFKJE": "Jumlah belum dibayar",
    "FuKuanFangShi": "Cara Pembayaran",
    "FuJian": "Lampiran",
    "ZHYFZ": "Akaun telah disalin",
    "GHSKZH": "Tukar akaun penerimaan",
    "SYXXZFQSCF": "Gunakan pembayaran luar talian sila muat naik tangkapan skrin pembayaran, untuk kewangan mengesahkan jumlah!",
    "XXZF_BXXZS": "Pembayaran luar talian, mesti pilih akaun penerimaan",
    "DingDanZhiFu": "Pembayaran Pesanan",
    "ZFFS_HDFK": "Cara pembayaran: Bayar pada penerimaan",
    "BCFKJE": "Jumlah pembayaran kali ini",
    "YuE": "Baki",
    "FuZhiZhangHao": "Salin akaun",
    "WSZXCXZFPZ": "Belum tetapkan konfigurasi pembayaran mini program",
    "XCXZFZHJY": "Akaun pembayaran mini program dinyatakan tidak sah",
    "SRZFJE": "Masukkan jumlah pembayaran",
    "FuKuanZhangHu": "Akaun Pembayaran",
    "QueRenZhiFu": "Pasti Pembayaran",
    "ShaoHouZhiFu": "Bayar kemudian",
//order
    "FKJLYTJ_DD": "Rekod pembayaran telah ditambah, menunggu审核 kewangan",
    "JiXuGuang": "Terus menjelajah",
    "BenCiFuKuan": "Pembayaran kali ini",
    "FuKuanChengGong": "Pembayaran berjaya",
    "ZhiFuFangShi": "Cara Pembayaran",
    "ZhiFuDingDan": "Pesanan Pembayaran",
//order-batch-pay
    "QXXZSXZFDD": "Sila pilih pesanan yang perlu dibayar terlebih dahulu",
    "PiLiangFuKuan": "Pembayaran Berkelompok",
    "FuKuan": "Bayar",
    "'QuFuKuan'": "Pergi bayar",
//order-create-result
    "YingFuJinE": "Jumlah perlu bayar",
    "XiaDanShiJian": "Masa Pesanan",
//order-deliver
    "SFQRSH": "Adakah anda pasti ingin mengesahkan penerimaan?",
    "DDQRSH_": "Adakah pesanan mengesahkan penerimaan?",
    "DFHSP": "Produk menunggu penghantaran",
    "ShangPinShuLiang": "Jumlah Produk",
    "ChuKuShiJian": "Masa Keluar Gudang",
    "FaHuoShiJian": "Masa Penghantaran",
    "WuLiuBeiZhu": "Nota Logistik",
    "QueRenShouHuo": "Pasti Penerimaan",
    "RYFK_QJSYG": "Jika telah bayar, sila hubungi pentadbir segera",
    "QSRQXYY": "Sila masukkan sebab pembatalan",
    "H_DDJZDGB_QJKF": "setelah itu, pesanan akan自动 ditutup, sila bayar segera",
    "TuiHuoQingKuang": "Status Pengembalian",
    "DingDanZongE": "Jumlah Keseluruhan Pesanan",
    "DingDanBeiZhu": "Nota Pesanan",
    "FaHuoQingKuang": "Status Penghantaran",
    "DingDanFuJian": "Lampiran Pesanan",
    "ShenQingTuiHuo": "Permohonan Pengembalian",
    "G1TDSHJL_QRS": "Jumlah {num} rekod menunggu penerimaan, adakah pasti mengesahkan penerimaan?",
    "DaiXiaDan": "Pesanan bagi pihak lain",
    "DingDanHao": "No. Pesanan",
    "XiaDanFangShi": "Cara Pesanan",
    "TuiHuoDan": "Borang Pengembalian",
    "ShangPinZongE": "Jumlah Keseluruhan Produk",
    "YunFei_ZongZhong": "Yuran penghantaran (berat keseluruhan",
    "SF_SPWS": "Cukai (produk tanpa cukai",
    "TePiJia": "Harga istimewa",
    "FuKuanQingKuang": "Status Pembayaran",
    "TiaoJiLu": "rekod",
    "ZaiLaiYiDan": "Pesan lagi",
    "QDSCGDD_": "Pasti ingin memadam pesanan ini?",
    "YiQueRen": "Telah dikonfirmasi",
    "YiShouHuo": "Telah diterima",
    "DaiFuJinE": "Jumlah belum dibayar",
    "YiFuJinE": "Jumlah telah dibayar",
    "ZanWuJiLu": "Tiada rekod",
    "SPMC_DDH": "Nama Produk / No. Pesanan",
    "FuKuanZhuangTai": "Status Pembayaran",
    "FaHuoZhuangTai": "Status Penghantaran",
    "QiShiShiJian": "Masa Mula",
    "ZhongZhiShiJian": "Masa Tamat",
//order-list
    "CaoZuoChengGong": "Operasi berjaya",
    "ZBKGM": "Tidak boleh dibeli buat masa ini",
    "DQDDSPYXJ": "Produk pesanan semasa telah dikeluarkan dari platform",
    "DQDDBFSPYXJ": "Sebahagian produk pesanan semasa telah dikeluarkan dari platform",
    "JTJSJSP": "Hanya tambah produk yang dimasukkan platform",
    "DingHuoDan": "Borang Pesanan",
//order-log
    "DingDanRiZhi": "Rekod Pesanan",
//order-logistics
    "FuZhiChengGong": "Salinan berjaya",
    "FuZhiShiBai": "Salinan gagal",
    "FuZhi": "Salin",
    "BoDa": "Hubungi telefon",
    "WCWLDHXX": "Tiada maklumat no. resi logistik ini",
//order-pay
    "ZFCS_QCXXD": "Pembayaran luput masa, sila pesan semula",
    "YQYYCKZF": "Pembayaran dengan wang simpanan awal telah diaktifkan",
    "BNDYDFKJE": "Tidak boleh lebih daripada jumlah belum dibayar",
    "ZFJEBNWK": "Jumlah pembayaran tidak boleh kosong",
    "QXAPFK_FKH": "Sila atur pembayaran terlebih dahulu, selepas bayar, tangkapan skrin dan muat naik maklumat pembayaran, untuk kewangan mengesahkan jumlah",
    "DDTJCG_QJS": "Pesanan berjaya dihantar, sila bayar segera",
    "QXZFKFS": "Sila pilih cara pembayaran",
    "SYYEZFH_HX": "Selepas menggunakan pembayaran baki, masih perlu bayar",
//
    "FuKuanJiLu": "Rekod Pembayaran",
    "ZWFKJL": "Tiada rekod pembayaran",
    "FuKuanXiangQing": "Butiran Pembayaran",
    "FuKuanJinE": "Jumlah Pembayaran",
    "ZhiDan": "Cipta dokumen",
    "ShenHe": "审核",
    "ZuoFei": "Musnahkan",
    "ZuoFeiYuanYin": "Sebab Musnah",
    "GLDHD": "Borang Pesanan berkaitan",
    "HeXiaoJinE": "Jumlah Verifikasi",
    "HeXiaoZhuangTai": "Status Verifikasi",
    "DanJuZhuangTai": "Status Dokumen",
    "KeHuMingCheng": "Nama Pelanggan",
    "ZhangDanHao": "No. Bil",
    "ShouKuanZhangHao": "Akaun Penerimaan",
    "ShouKuanShiJian": "Masa Penerimaan",
    "FuKuanPingZheng": "Bukti Pembayaran",
    "GeFuJian": "lampiran",
//order-statistics
    "DingDanTongJi": "Statistik Pesanan",
    "DingHuo": "Pesanan",
    "Bi": "transaksi",
//order-statistics-detail
    "DDTJMX": "Butiran Statistik Pesanan",
    "AGGTJ": "Statistik mengikut spesifikasi",
    "AFLTJ": "Statistik mengikut kategori",
    "DDJE_Y": "Jumlah Pesanan/yuan",
    "DHSP_Z": "Produk Pesanan/jenis",
    "DingHuoDan_Bi": "Borang Pesanan/transaksi",
    "DingHuoShangPin": "Produk Pesanan",
    "JinE": "Jumlah",
//refund-list
    "TuiHuo": "Pengembalian",
//refund-apply
    "THDHWBC_QD": "Borang pengembalian belum disimpan, pasti ingin keluar?",
    "QSRSQTHJE": "Sila masukkan jumlah pengembalian yang diminta",
    "QSRTHJE": "Sila masukkan jumlah pengembalian",
    "QSRBZXX": "Sila masukkan maklumat nota",
    "YingTuiJinE": "Jumlah perlu dikembalikan",
    "TJTHSQ": "Hantar permohonan pengembalian",
    "QXXZDHQD": "Sila pilih senarai pesanan terlebih dahulu",
    "DingHuoQingDan": "Senarai Pesanan",
    "SQTHJE": "Jumlah pengembalian yang diminta",
    "DJXZSP": "Klik untuk pilih produk",
    "TuiHuoJinE": "Jumlah Pengembalian",
//refund-detail
    "THDDXQ": "Butiran Pesanan Pengembalian",
    "YiTuiHuo": "Telah dikembalikan",
    "YiTuiKuan": "Telah dibayar balik",
    "THDZT": "Status Borang Pengembalian",
    "TuiHuoDanHao": "No. Borang Pengembalian",
    "TuiHuoShiJian": "Masa Pengembalian",
    "TuiHuoCangKu": "Gudang Pengembalian",
    "THLXR": "Penghubung Pengembalian",
    "TuiHuoQingDan": "Senarai Pengembalian",
    "TuiKuanZongE": "Jumlah Keseluruhan Pembayaran Balik",
    "TuiKuanQingKuang": "Status Pembayaran Balik",
    "DaiTuiJinE": "Jumlah belum dikembalikan",
    "YiTuiJinE": "Jumlah telah dikembalikan",
//refund-product
    "SPMC_BH_GG": "Nama Produk / No. / No. Spesifikasi / Kod Bar",
    "GZD1TJG": "Jumlah jumpa 1 hasil",
    "JiaRuQingDan": "Tambah ke senarai",
//refund-result
    "ShenQingChengGong": "Permohonan berjaya",
    "THDTJCG": "Borang pengembalian berjaya dihantar",
    "ChaKanXiangQing": "Lihat butiran",
//goods-package-floor
    "HDWKS_WDZL": "Aktiviti belum bermula, datang lagi kemudian",
    "HDYJS_XCZD": "Aktiviti telah tamat, datang lebih awal next time",
    "ZWSZBT": "Tajuk belum ditetapkan",
    "ChaKanGengDuo": "Lihat lebih banyak",
//goods-promotion-floor
    "HCDZSJC": "Perbezaan masa disebabkan cache",
    "DLCKCXJ": "Log masuk untuk melihat harga promosi",
    "ZWSZCX": "Promosi belum ditetapkan",
    "JuKaiShi": "Masa tinggal sehingga mula",
    "Song": "Berikan",
    "JuJieShu": "Masa tinggal sehingga tamat",
    "YiJieShu": "Telah tamat",
//search-floor
    "XiaoXi": "Mesej",
    "SaoMaXiaDan": "Scan untuk membuat pesanan",
//home-page-custom
    "WZLCSJ": "Data tingkat tidak diketahui",
//jump-error
    "QXZYSDHAPP": "Sila muat turun aplikasi Yunshang Order",
    "QMTYQYGLD": "Pengalaman penuh pihak pengurusan syarikat",
    "XZYSDHAPP": "Muat turun aplikasi Yunshang Order",
    "HQGLDWZTY": "Dapatkan pengalaman penuh pihak pengurusan",
    "JXTYDHD": "Terus pengalaman pihak pesanan",
//notice-detail
    "GongGaoXiangQing": "Butiran Pengumuman",
    "GongGaoFuJian": "Lampiran Pengumuman",
//shop-error
    "NFWDYMBCZO": "Laman yang anda lawati tidak wujud~",
    "KeNengYuanYin": "Sebab mungkin",
    "1_ZDZLSRCWD": "1. Memasukkan alamat salah di bar alamat;",
    "2_DJLGQLJ": "2. Klik pautan yang telah luput.",
//shop-index
    "GuanLiDuan": "Pihak Pengurusan",
    "ZhuCe": "Daftar",
    "HYNTYYSDH": "Selamat datang menggunakan Yunshang Order",
    "TYZHSJHDQG": "Data akaun uji cuba akan dikemas kini secara berkala, jangan masukkan maklumat penting",
    "TYZHZDNRSJ": "Semua data kandungan dalam akaun uji cuba adalah fiktif, jangan masukkan maklumat penting",
    "ZHZCCG": "Pendaftaran akaun berjaya",
    "DengLuZhangHao": "Akaun Log Masuk",
    "CSMMW": "Kata laluan awal ialah",
    "GNFYHQL": "Kami menghantar kupon kepada anda!",
    "Man1YuanKeYong": "Boleh digunakan apabila mencapai {num} yuan",
    "LQH1TNKY": "Boleh digunakan dalam {day} hari selepas menerima kupon",
    "YiJianLingQu": "Terima dengan satu klik",
    "GXNHD1ZYHQ": "Tahniah anda mendapatkan 1 kupon",
    "Gong1Yuan": "Jumlah 1 yuan",
    "LiJiShiYong": "Gunakan segera",
//shop-login
    "NHWDL": "Anda belum log masuk",
//shop-notice
    "ShangChengGongGao": "Pengumuman Mall",
    "ZanWuGongGao": "Tiada pengumuman",
    "1GeFuJian": "{num} lampiran",
//deposit-detail
    "KouKuan": "Penolakan wang",
    "ChongZhi_Kuan": "Isi semula",
    "KouKuanZuoFei": "Membatalkan penolakan wang",
    "ChongZhiZuoFei": "Membatalkan isi semula",
    "ZhangHuMingXi": "Butiran Akaun",
    "ZhangHuYuE": "Baki Akaun",
    "LiJiChongZhi": "Isi semula segera",
//deposit-recharge
    "CZJEBNXY1Y": "Jumlah isi semula tidak boleh kurang daripada 1 yuan",
    "QSRZQDSZ": "Sila masukkan nilai yang betul",
    "ZDYJE": "Jumlah tersuai",
    "ZWKTXSCZGN": "Fungsi isi semula dalam talian belum dibuka",
    "ShiFuJinE": "Jumlah sebenarnya dibayar",
    "ZhangHuChongZhi": "Isi semula Akaun",
    "QXZCZJE": "Sila pilih jumlah isi semula",
    "QSRCZJE": "Sila masukkan jumlah isi semula",
    "QLXNDZSYWY": "Sila hubungi jurujual eksklusif anda untuk isi semula",
    "ShouJia": "Harga Jualan",
    "YiShouQing": "Telah habis",
    "ChongZhiJinE": "Jumlah Isi Semula",
    "QueRenFuKuan": "Pasti Pembayaran",
//deposit-recharge-result
    "QSDDID": "Tiada ID pesanan",
    "ChongZhiChengGong": "Isi semula berjaya",
    "ChongZhiShiBai": "Isi semula gagal",
    "CLZ_QSH...": "Sedang diproses, sila tunggu...",
    "ChongZhiFangShi": "Cara Isi Semula",
    "ChongZhiShiJian": "Masa Isi Semula",
    "JYLSH": "No. Urut Transaksi",
    "FanHuiShangCheng": "Kembali ke Mall",
//recharge-online
    "ZFSB_QCS": "Pembayaran gagal, sila cuba semula",
    "ZFYQX": "Pembayaran telah dibatalkan",
    "ZFYC_QCS": "Pembayaran tidak normal, sila cuba semula",
//user
    "LingQuanZhongXin": "Pusat Terima Kupon",
    "WeiShiYong": "Belum digunakan",
    "YiShiYong": "Telah digunakan",
    "ZWYHQ": "Tiada kupon",
//keep-list
    "YiGouMai": "Telah membeli",
    "ChangYongQingDan": "Senarai Kerap Digunakan",
    "WoDeShouCang": "Koleksi Saya",
    "QuGouWuChe": "Pergi ke kereta belanja",
    "GeShangPin": "produk",
//login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Sila masukkan akaun!",
    "QSRMM": "Sila masukkan kata laluan!",
    "QSRDLZH": "Sila masukkan akaun log masuk",
    "JiZhuMiMa": "Ingat kata Laluan",
    "WangJiMiMa": "Lupa kata Laluan?",
    "DengLu": "Log Masuk",
    "DLZHBCZ_QL": "Akaun log masuk tidak wujud, sila hubungi pentadbir untuk membuka",
    "GQYZHSBJY_": "Akaun syarikat ini dinyatakan tidak sah, sila hubungi Yunshang Order",
    "GQYZHSYQJS": "Tempoh percubaan akaun syarikat ini tamat, sila hubungi Yunshang Order",
    "GQYZHYGQL": "Akaun syarikat ini telah luput, perlu menambah tempoh untuk digunakan, sila hubungi Yunshang Order",
    "LiJiTiYan": "Cuba segera",
//my-collect
    "YiChuChengGong": "Keluarkan berjaya",
    "QueHuo": "Tiada stok",
    "YCSCJ": "Keluarkan dari koleksi",
//order-message
    "SheZhiChengGong": "Tetapan berjaya",
    "ZWWDXX": "Tiada mesej belum dibaca",
    "QuanBuYiDu": "Semua telah dibaca",
    "DingDanXiaoXi": "Mesej Pesanan",
    "YiQiang": "Telah direbut",
    "LiJiLingQu": "Terima segera",
    "LingQuanHou": "Selepas menerima kupon",
    "TianNeiKeYong": "dalam hari boleh digunakan",
    "QSRSJH": "Sila masukkan nombor telefon",
    "QSRYZM": "Sila masukkan kod verifikasi",
    "QSRXMM": "Sila masukkan kata Laluan baru",
    "QSRZQSJGS": "Sila masukkan format telefon yang betul",
    "ChongZhiMiMa": "Tetapkan semula kata Laluan",
    "QSRNDSJHM": "Sila masukkan nombor telefon anda",
    "QSRDXYZ": "Sila masukkan verifikasi SMS",
    "HQYZM": "Dapatkan kod verifikasi",
    "HKCXHQ": "boleh dapatkan semula selepas",
    "QSR6_20WSZHZ": "Sila masukkan kata Laluan 6-20 aksara (nombor atau huruf)",
//share-setting
    "QSRSPJGBL": "Sila masukkan nisbah harga produk",
    "SPJGBLBXDY": "Nisbah harga produk mesti lebih besar atau sama dengan 100, dan kurang daripada 999.99",
    "DPMCZBZCTS": "Nama kedai tidak menyokong simbol khas buat masa ini",
    "LXRZBZCTSF": "Penghubung tidak menyokong simbol khas buat masa ini",
    "LXFSZBZCTS": "Cara hubungan tidak menyokong simbol khas buat masa ini",
    "LXDZZBZCTS": "Alamat hubungan tidak menyokong simbol khas buat masa ini",
    "DPJJZBZCTS": "Perihalan kedai tidak menyokong simbol khas buat masa ini",
    "QSRDPJJ_ZD": "Sila masukkan perihalan kedai, maksimum 50 aksara",
    "FenXiangSheZhi": "Tetapan Kongsi",
    "NDWSCSPJG": "Harga produk mall telefon bimbit anda",
    "NDDHJ_": "Harga pesanan anda ×",
    "LXXX_KBJ_": "Maklumat hubungan (boleh dikemaskini）",
    "DianPuMingCheng": "Nama Kedai",
    "JianJie": "Perihalan",
    "QSRDPMC": "Sila masukkan nama kedai",
    "LianXiRen": "Penghubung",
    "QSRLXR": "Sila masukkan penghubung",
    "LianXiFangShi": "Cara Hubungan",
    "QSRLXFS": "Sila masukkan cara hubungan",
    "LianXiDiZhi": "Alamat Hubungan",
    "QSRLXDZ": "Sila masukkan alamat hubungan",
//user
    "WoDeDingDan": "Pesanan Saya",
    "ZuiJinLiuLan": "Terbaru dilihat",
    "ShouCangShangPin": "Produk Koleksi",
    "BDYYZH_ZC": "Hubungkan akaun sedia ada | Daftar akaun baru",
    "DL_ZC": "Log Masuk | Daftar",
    "BangDingShouJi": "Hubungkan telefon",
    "TS_BDSJHM_": "Nota: Hubungkan nombor telefon, akaun lebih selamat!",
    "ChaKanQuanBu": "Lihat semua",
    "ShouHuoDiZhi": "Alamat Penerimaan",
    "LianXiWoMen": "Hubungi Kami",
    "SheZhi": "Tetapan",
    "QuQianDao": "Pergi tandatangan",
    "JiFenShangCheng": "Mall Poin",
    "TuiGuangShangPin": "Promosikan Produk",
    "QuChaKan": "Pergi lihat",
    "JiFenHuanLi": "Tukar hadiah dengan poin",
    "DYSPBQ": "Cetak tag produk",
//user-about
    "GYYSDH": "Tentang Yunshang Order",
    "YQHYSMEWM_": "Jemput rakan untuk scan kod QR, muat turun dan pasang terus",
    "DangQianBanBen": "Versi Semasa",
//user-address
    "ZWSHDZ": "Tiada alamat penerimaan",
    "WoDeDiZhi": "Alamat Saya",
    "ZhiNengShiBie": "Pengenalan pintar",
    "ZTDZXXKZNS": "Tampal maklumat alamat untuk mengenal pasti nama, telefon, alamat secara pintar",
    "MoRen": "Lalai",
    "QRSCDZ": "Pasti ingin memadam alamat?",
    "SHRXM": "Nama Penerima",
    "SJHMHGDDHZ": "Sekurang-kurangnya salah satu daripada nombor telefon bimbit atau tetap perlu diisi",
    "QSRSHRXM": "Sila masukkan nama penerima",
    "ShouJiHaoMa": "Nombor Telefon Bimbit",
    "GuDingDianHua": "Telefon Tetap",
    "QSRGDDH": "Sila masukkan telefon tetap",
    "SuoZaiDiQu": "Wilayah Tempat Tinggal",
    "QSRSZDQ": "Sila masukkan wilayah tempat tinggal",
    "QSRXXDZ": "Sila masukkan alamat terperinci!",
    "QSRZQDSJHM": "Sila masukkan nombor telefon bimbit yang betul",
    "QSRZQDGDDH": "Sila masukkan telefon tetap yang betul",
    "XiangXiDiZhi": "Alamat Terperinci",
    "MoRenDiZhi": "Alamat Lalai",
    "SWMRDZ": "Tetapkan sebagai alamat lalai",
    "BCBSY": "Simpan dan gunakan",
//user-bing-one
    "QSRSJHM": "Sila masukkan nombor telefon",
    "GYHYZC": "Pengguna ini telah daftar",
    "GSJHMYJZCG": "Nomor telefon ini telah didaftar",
    "QZJDLJK": "Sila log masuk terus",
    "QuDengLu": "Pergi log masuk",
    "BDHKYTGSJH": "Selepas hubungkan, boleh log masuk melalui nombor telefon, memudahkan anda mendapatkan semula kata Laluan, meningkatkan keselamatan akaun",
    "_BDHKYTGSJ": "*Selepas hubungkan, boleh log masuk melalui nombor telefon, memudahkan anda mendapatkan semula kata Laluan, meningkatkan keselamatan akaun",
    "QSRSJYZM": "Sila masukkan kod verifikasi telefon",
    "BDXSJ": "Hubungkan telefon baru",
    "DXYZM": "Kod verifikasi SMS",
    "XiaYiBu": "Langkah seterusnya",
    "TGCBZ": "Langkau langkah ini",
//user-bing-two
    "DBDSJHMBCZ": "Nomor telefon yang akan dihubungkan tidak wujud!",
    "QSRDLMM": "Sila masukkan kata Laluan log masuk!",
    "_GSJHMYBDY": "*Nomor telefon ini telah dihubungkan dengan akaun Yunshang Order, sahkan kata Laluan log masuk telefon, untuk hubungkan akaun semasa",
    "DQZHMMJTBW": "Kata Laluan akaun semasa akan disegerakkan menjadi kata Laluan log masuk telefon",
    "DangQianZhangHao": "Akaun Semasa",
//
    "QDYJZ": "Pasti ingin memadam",
    "JSPSCM": "produk ini?",
    "ShanChuChengGong": "Padam berjaya!",
//user-info
    "SJGSCW": "Format telefon salah",
    "YXGSCW": "Format emel salah",
    "WoDeZhangHao": "Akaun Saya",
    "YouXiang": "Emel",
    "ShouJi": "Telefon",
    "XingMing": "Nama",
    "XiuGaiTouXiang": "Kemaskini avatar",
    "JiBenXinXi": "Maklumat Asas",
    "ZhangHaoAnQuan": "Keselamatan Akaun",
    "XiuGaiMiMa": "Kemaskini kata Laluan",
    "DianJiBangDing": "Klik untuk hubungkan",
    "RYDSHTY_QL": "Jika hilang atau tidak digunakan lagi, sila tukar segera, elakkan akaun dicuri",
    "WBZNDZHAQ_": "Untuk menjamin keselamatan akaun anda, sila hubungkan telefon",
    "QSRNDXM": "Sila masukkan nama anda",
    "QSRNDDH": "Sila masukkan telefon anda",
    "QSRNDYX": "Sila masukkan emel",
//user-setting
    "QCHCHXCXDL": "Selepas membersihkan cache, perlu log masuk semula",
    "QingChuHuanCun": "Membersihkan Cache",
    "QDYQCHCM": "Pasti ingin membersihkan cache?",
    "TuiChuDengLu": "Log Keluar",
    "QieHuanZhangHao": "Tukar Akaun",
//user-supplier
    "LianXi": "Hubungi",
    "GongSiDianHua": "Nomor Telefon Syarikat",
    "DiZhi": "Alamat",
//vouchers-detail
    "DJQMX": "Butiran Kupon Wang Tunai",
//vouchers-list
    "BuKeYong": "Tidak boleh digunakan",
    "KeYong": "Boleh digunakan",
    "ZWDJQ": "Tiada kupon wang tunai",
    "ZongEDu": "Jumlah Had",
    "FaFangShiJian": "Masa Pengedaran",
    "EDYYW": "Had telah habis",
    "QBSPKY": "Boleh digunakan untuk semua produk",
//vouchers-select-list
    "WDDJQ": "Kupon Wang Tunai Saya",
    "KYDJQ": "Kupon Wang Tunai Boleh Digunakan",
    "DJQKDK": "Kupon Wang Tunai Boleh Ditolak",
    "CKKYSP": "Lihat produk boleh digunakan",
    "BKYDJQ": "Kupon Wang Tunai Tidak Boleh Digunakan",
    "BKYYY_ZWFH": "Sebab tidak boleh digunakan: Tiada produk memenuhi syarat",
//goods-detail
    "DQSPWSCGGT": "Produk semasa belum muat naik gambar spesifikasi, tidak menyokong memasang lampu!",
    "BoFangShiPin": "Main video",
    "Gong1GeGuiGe": "Jumlah {num} spesifikasi",
    "YiXuanGuiGe": "Spesifikasi telah dipilih",
    "XuanGuiGe": "Pilih spesifikasi",
    "LingQuan": "Terima kupon",
    "1ZhongCuXiao": "1 jenis promosi",
    "1ZhangKeYong": "1 helai boleh digunakan",
    "ZuiGaoKeSheng": "Jimat maksimum",
    "ShangPinTaoCan": "Paket Produk",
    "Gong1GeTaoCan": "Jumlah 1 paket",
    "ShangPinCanShu": "Parameter Produk",
    "ZhanKai": "Buka",
    "YiShouCang": "Telah koleksi",
    "ShouCang": "Koleksi",
    "KeFu": "Pelayanan Pelanggan",
    "XiangQing": "Butiran",
    "TuiJian": "Syorkan",
    "BianHao": "No.",
    "ShangPinXinXi": "Maklumat Produk",
    "KLYHQ": "Boleh terima kupon",
    "KuCunBuZu": "Stok tidak mencukupi",
    "DuoGuiGe": "Berbilang spesifikasi",
    "YiShou": "Telah dijual",
    "SWBHZ_YS": "Sedang mengisi stok, telah dijual",
    "CuXiaoShangPin": "Produk Promosi",
//goods-search
    "NHWSRSSNR": "Anda belum masukkan kandungan carian",
    "SouSuo": "Cari",
    "SSY1XGDSP": "Cari produk berkaitan dengan {searchKey}",
    "Yue1GeShangPin": "Kira-kira {num} produk",
    "ZuiJinSouSuo": "Carian Terbaru",
    "QingChu": "Bersihkan",
    "ZWSSJL": "Tiada rekod carian",
//goods-property
    "ZGJGBNDYZD": "Harga tertinggi tidak boleh kurang daripada harga terendah",
    "ShangPinBiaoQian": "Tag Produk",
    "BuGaoYu1": "Tidak lebih daripada 1",
    "BuDiYu1": "Tidak kurang daripada 1",
    "FengGe": "Gaya",
//goods-promotion-list
    "JiJiangKaiShi": "Akan bermula",
    "QuanBuCuXiao": "Semua Promosi",
//goods-package-list
    "Gong1JianShangPin": "Jumlah 1 produk",
    "Sheng": "Jimat",
//goods-package-detail
    "GTCZGWCZDS": "Jumlah paket dalam kereta belanja telah mencapai had pembelian, tidak boleh dimasukkan ke kereta belanja",
    "GTCKCBZ_BK": "Stok paket ini tidak mencukupi, tidak boleh dimasukkan ke kereta belanja",
    "JinSheng1Tao": "Hanya baki 1 set",
    "XianGou1Tao": "Had pembelian 1 set",
    "TaoCanXiangQing": "Butiran Paket",
    "DanMaiJia": "Harga Beli Tunggal",
    "TaoCanJia": "Harga Paket",
    "HDYJS": "Aktiviti telah tamat",
//goods-message
    "WDL_QXDL": "Belum log masuk, sila log masuk terlebih dahulu",
//goods-list-label
    "XinPinShangShi": "Produk Baru Dilaunch",
    "WDLZH_ZWCX": "Belum log masuk akaun, tiada aktiviti promosi!",
    "YiXiaShangPin": "Produk di bawah",
//goods-list
    "1ZhongGuiGe": "1 jenis spesifikasi",
    "YouKuCun": "Terdapat stok",
//goods-filter
    "BuGaoYu": "Tidak lebih daripada",
    "BuDiYu": "Tidak kurang daripada",
    "CuXiao": "Promosi",
    "ZDYXXZ3G": "Maksimum dibenarkan pilih 3",
    "GouMai": "Beli",
    "Gong1Jian": "Jumlah {num} produk",
//已订货商品
    "DLHCKJG": "Log masuk untuk melihat harga",
    "M1JZ1J": "Hadiah {presentNum} produk apabila mencapai {num} produk",
    "CZPF_ZZCXC": "Operasi terlalu kerap, sedang cuba semula",
    "XSZJJXZ": "Penurunan harga terhad masa sedang berlangsung",
    "YXSPM1YZ1J_": "Produk di bawah {str}, masukkan ke kereta belanja untuk享受 diskaun!",
    "TiaoXingMa": "Kod Bar",
    "XiangGuanTuiJian": "Syorkan Berkaitan",
    "YSSPBKJRGW": "Produk prapemesanan tidak boleh dimasukkan ke kereta belanja, telah tambah produk bukan prapemesanan untuk anda!",
    "YSSPBKLJGM": "Produk prapemesanan tidak boleh dibeli segera, sila keluarkan produk prapemesanan dan beli semula!",
    "SPSLYW": "Jumlah produk salah",
    "ShangPin1QiShou": "Produk bermula dijual dari {num}",
    "SPDGSLBNCG": "Jumlah pesanan produk tidak boleh melebihi {num}",
    "QRYCXZSP": "Pasti ingin keluarkan produk yang dipilih",
    "QRYCSYSXSP": "Pasti ingin keluarkan semua produk tidak sah",
    "QRYCXZSXSP": "Pasti ingin keluarkan produk tidak sah yang dipilih",
    "M1YZ1J": "Hadiah {presentNum} produk apabila mencapai {num} yuan",
    "M1YJ1Y": "Diskaun {money} yuan apabila mencapai {price} yuan",
    "M1J1": "Diskaun {money} apabila mencapai {price}",
    "M1YD1Z": "Diskaun {money}% apabila mencapai {price} yuan",
    "DDM1YHZ": "Pesanan mendapat hadiah apabila mencapai {price} yuan",
    "YiHuoZeng": "Telah mendapat hadiah",
    "ZG1YLXM1YZ1": "Beli lagi {price} yuan untuk享受 {str}",
    "ZG1JLXM1JZ1": "Beli lagi {num} produk untuk享受 {str}",
    "QCSXSP": "Bersihkan produk tidak sah",
    "YiXuanShangPin": "Produk telah dipilih",
    "QuJieSuan": "Pergi penyelesaian",
    "ShiXiaoShangPin": "Produk Tidak Sah",
    "DingDanGuanLi": "Pengurusan Pesanan",
    "ZhuangTai": "Status",
    "ShangPinChuKu": "Produk Keluar Gudang",
    "DengDaiShouHuo": "Menunggu Penerimaan",
    "PeiSongXinXi": "Maklumat Penghantaran",
    "FuKuanXinXi": "Maklumat Pembayaran",
    "GDFKJL": "Lebih banyak rekod pembayaran",
    "WuLiuFuJian": "Lampiran Logistik",
    "ZanWuFuJian": "Tiada Lampiran",
    "YiFa": "Telah dihantar",
    "YingFuZongE": "Jumlah Keseluruhan Perlu Bayar",
    "FuKuanShiJian": "Masa Pembayaran",
    "ZhangHuHaoMa": "No. Akaun",
    "KeYongYuE": "Baki Boleh Digunakan",
    "TianJiaChengGong": "Tambah berjaya",
    "ShanChuDiZhi": "Padam Alamat",
    "QXZSHDZ": "Sila pilih alamat penerimaan",
    "YiHuoZengPin": "Telah mendapat produk hadiah",
    "YiYouHui1Yuan": "Telah mendapat diskaun {money} yuan",
    "QWSFPXX": "Sila lengkapkan maklumat bil",
    "1ZSP": "{num} jenis produk",
    "Gong": "Jumlah",
    "Jian": "produk",
    "ShangPinJinE": "Jumlah Produk",
    "YunFeiDaoFu": "Yuran penghantaran dibayar semasa penerimaan",
    "QSRZQDSHRX": "Sila masukkan nama penerima yang betul",
    "QSRZQDXXDZ": "Sila masukkan alamat terperinci yang betul",
    "DBQ_MYZDDY": "Maaf, tidak jumpa laman sepadan",
    "ShouHuoChengGong": "Penerimaan berjaya",
    "Hi_HuanYingNin": "Hi, selamat datang",
    "YiFaEWuLiu": "Telah hantar e-logistik",
    "NinDeDingDan": "Pesanan anda",
    "ZBNBHBQ": "tidak boleh mengandungi emoji",
    "XMBNWK": "Nama tidak boleh kosong",
    "XiTongSheZhi": "Tetapan Sistem",
    "ZhangHaoXinXi": "Maklumat Akaun",
    "QingShuRuXingMing": "Sila masukkan nama",
    "QWSZL_JZYG": "Sila lengkapkan profil, membantu memberikan perkhidmatan yang lebih baik",
    "QSRZQDYXGS": "Sila masukkan format emel yang betul",
    "QTXZQDCWXX": "Sila isi maklumat kewangan yang betul, untuk rakan kongsi anda mencetak bil untuk anda",
    "GXSHDZCG": "Kemas kini alamat penerimaan berjaya",
    "BCSHDZCG": "Simpan alamat penerimaan berjaya",
    "XinZengDiZhi": "Tambah Alamat Baru",
    "QXZYQXSCDS": "Sila pilih produk yang akan batalkan koleksi",
    "QuXiaoShouCang": "Batalkan Koleksi",
    "XuanZeGuiGe": "Pilih Spesifikasi",
    "CaiWuGuanLi": "Pengurusan Kewangan",
    "DuiZhangMingXi": "Butiran Penyegerakan Akaun",
    "QSRLWJL_JE": "Sila masukkan rekod hubungan/jumlah",
    "YiGouMai1Ci": "Telah membeli {count} kali",
    "6_1GouMai": "{time} membeli",
    "TZGGXQ": "Butiran Pengumuman Notis",
    "ZYXSCSP": "Hanya dibenarkan muat naik video",
    "SCSPDXBYXC": "Saiz video yang dimuat naik tidak boleh melebihi {size}",
    "YDHSP": "Produk Telah Dipesan",
    "ShangPinPinPai": "Jenama Produk",
    "ShangPinLieBiao": "Senarai Produk",
    "LingShouJia": "Harga Runcit",
    "YouHuiJia": "Harga Diskaun",
    "LiJiGouMai": "Beli Segera",
    "ZhuTu": "Gambar Utama",
    "WuXianZhi": "Tiada Had",
    "XiaoJi": "Subjumlah",
    "SCXZSP": "Padam Produk yang Dipilih",
    "QSRDDH": "Sila masukkan no. pesanan",
    "QSRDDH_SPMC": "Sila masukkan no. pesanan/nama produk",
    "CaoZuo": "Operasi",
    "WuLiuXinXi": "Maklumat Logistik",
    "CaoZuoLeiXing": "Jenis Operasi",
    "CaoZuoRiZhi": "Rekod Operasi",
    "CaoZuoShiJian": "Masa Operasi",
    "ZhangHuMingCheng": "Nama Akaun",
    "KaiHuYinHang": "Bank Pembuka Akaun",
    "DDTJCG_XZZC": "Pesanan berjaya dihantar, hanya tinggal langkah terakhir",
    "ZhiFuJinE": "Jumlah Pembayaran",
    "DZFJE": "Jumlah Belum Dibayar",
    "QTXYXSMB": "Isi beberapa keterangan",
    "XZSKYHZH": "Pilih akaun bank penerimaan",
    "TiShi": "Nota",
    "NHY1GDDGJ1Y": "Anda masih mempunyai {num} pesanan dengan jumlah {money} yuan belum dibayar",
    "QKJQHCKJXX": "Perlu menyelesaikan hutang sebelum membuat pesanan lagi",
    "HDDDXX": "Semak maklumat pesanan",
    "BJSHDZ": "Kemaskini alamat penerimaan",
    "TongZhiGongGao": "Notis Pengumuman",
    "YinHangZhangHao": "No. Akaun Bank",
    "XiuGaiShouJi": "Kemaskini telefon",
    "LXRXX": "Maklumat Penghubung",
    "GSCWXX": "Maklumat Kewangan Syarikat",
    "QSRKHYHMCJ": "Sila masukkan nama bank pembuka akaun dan cawangan pembuka",
    "QSRYHZH": "Sila masukkan no. akaun bank",
    "PiLiangCaoZuo": "Operasi Berkelompok",
    "GouMaiJiLu": "Rekod Pembelian",
    "TongZhiBiaoTi": "Tajuk Notis",
    "FaBuShiJian": "Masa Pengedaran",
    "XiaoXiLeiXing": "Jenis Mesej",
    "XiaoXiNeiRong": "Kandungan Mesej",
    "JieShouShiJian": "Masa Penerimaan",
    "QuanBuPinPai": "Semua Jenama",
    "WXSYS_DHGBJ": "Scan QR WeChat, pesanan lebih mudah",
    "GZWXGZH": "Ikuti akaun rasmi WeChat",
    "FuWuReXian": "Hotline Perkhidmatan",
    "SouSuoLiShi": "Rekod Carian",
    "QuanBuShanChu": "Padam Semua",
    "NH_HYLDYSDH": "Halo, selamat datang ke {company}!",
    "ZSJDH": "Pesan di telefon bimbit",
    "SYS_GZWXGZH": "Scan, ikuti akaun rasmi WeChat",
    "GuanZhuWoMen": "Ikuti Kami",
    "QBSPFL": "Semua Kategori Produk",
    "QuPeiDeng": "Pergi memasang lampu",
    "KuanXiang": "Jumlah Wang",
    "QSRSPMC_GG_": "Sila masukkan nama produk/spesifikasi/no./huruf pertama",
    "NH_HYLDYSD": "Halo, selamat datang ke Mall Yunshang Order!",
    "ReXiao": "Popular",
    "20Tiao_Ye": "20 baris/halaman",
    "ShiChangJia_": "Harga Pasaran：",
    "_134.10Qi": "Mula dari S/ 134.10",
    "HJ_BHYF": "Jumlah (tanpa yuran penghantaran)：",
    "QDSCXZSP_": "Pasti ingin padam produk yang dipilih?",
    "QDQCXJSP_": "Pasti ingin bersihkan produk dikeluarkan platform?",
    "DDTJCG_XZZ": "Pesanan berjaya dihantar, hanya tinggal langkah terakhir!",
    "XuanZeZhangHu": "Pilih Akaun",
    "DaiZhiFu": "Belum Dibayar",
    "CaiGouDingDan": "Pesanan Pembelian",
    "DingDanXinXi": "Maklumat Pesanan",
    "TuiChu": "Keluar",
    "KaiHuMingCheng": "Nama Pembuka Akaun",
    "QSRKHMC": "Sila masukkan nama pembuka akaun",
    "_QTXZQDCWX": "（Sila isi maklumat kewangan yang betul, untuk rakan kongsi anda mencetak bil untuk anda）",
    "ShouHuoRen": "Penerima",
    "SWMRSHDZ": "Tetapkan sebagai alamat penerimaan lalai",
    "TianJiaDiZhi": "Tambah Alamat",
    "Gong4GeGuiGe": "Jumlah 4 spesifikasi",
    "Zhi": "Hanya",
    "Kuai": "sekeping",
    "Tou": "ekor",
    "Xiang": "kotak",
    "Ping": "botol",
    "KaiShiRiQi": "Tarikh Mula",
    "JieShouRiQi": "Tarikh Tamat",
    "YiXuan": "Telah Dipilih",
    "ZhiFuZhuangTai": "Status Pembayaran",
    "QDLCKJG": "Sila log masuk untuk melihat harga",
    "YZMBZQ": "Kod verifikasi salah",
       "ZhiFuJiLu": "Rekod Pembayaran",
    "ShangPinMingCheng": "Nama Produk",
    "DingGouShuLiang": "Jumlah Pesanan",
    "TuiHuoShuLiang": "Jumlah Pengembalian",
    "QSRTHNR": "Sila masukkan kandungan pengembalian",
    "SCTHSM": "Muat naik keterangan pengembalian",
    "ShenQingShiJian": "Masa Permohonan",
    "ShenQingJinE": "Jumlah Permohonan",
    "TuiHuoYuanYin": "Sebab Pengembalian",
    "TuiHuoShuoMing": "Keterangan Pengembalian",
    "TuiDanHao": "No. Borang Pengembalian",
    "SXCZ_XDCG": "Kredit mencukupi, pesanan berjaya",
    "SXEDBZ_FKHFH": "Kredit tidak mencukupi, penghantaran selepas pembayaran",
    "CGJKZQ_FKFH": "Melebihi tempoh pinjaman, penghantaran selepas pembayaran",
    "DDTJCG_XZZCZHYB": "Pesanan berjaya dihantar, hanya tinggal langkah terakhir!",
    "QNZ_NWCFK_FZ": "Sila selesaikan pembayaran dalam {time}, jika tidak pesanan akan dibatalkan secara automatik.",
    "MianFeiLing": "Terima Percuma",
    "M_KMFLQ_HQ": "Boleh terima percuma apabila mencapai {target} yuan, masih kekurangan {short} yuan",
    "YHDMFSP": "Telah mendapat produk percuma",
    "JRMFL": "Terima Percuma Hari Ini",
    "LingGuangLe": "Telah habis diterima",
    "KeLingQu": "Boleh diterima",
    "QSRZFJE": "Sila masukkan jumlah pembayaran",
    "QNJKFK_WMJKWNCL": "Sila bayar segera, kami akan proses pesanan anda secepatnya!",
    "XianXiaTiYanGuan": "Pusat Eksperimen Luar Talian",
    "QingXuanZheSheng": "Sila pilih Negeri",
    "QingXuanZheShi": "Sila pilih Bandar",
    "ZhanGuanDiZhi": "Alamat Pameran",
    "YingYeShiJian": "Masa Operasi",
    "ZhanGuanDianHua": "Nomor Telefon Pameran",
    "FenXiang": "Kongsi",
    "TiYanGuanJieShao": "Keterangan Pusat Eksperimen",
    "DPYDY_QSHX": "Kedai telah ditutup, sila pesan kemudian",
    "DaYangShiJian": "Masa Penutupan",
    "IMEI": "Kod IMEI",
    "FanKuanYuE": "Baki Refund",
    "FanKuanZhiFu": "Pembayaran Refund",
    "YiShengZhiFu": "Pembayaran Yisheng",
    "JiongDongShouYinTai": "Kaunter Kas Jingdong",
    "FKYEBZ": "Baki Refund tidak mencukupi",
    "FanKuanZhangHu": "Akaun Refund",
    "HaiXuZhiFu": "Masih perlu bayar {price}",
    "FaPiaoMingXi": "Butiran Bil",
    "FaPiaoZhuShou": "Pembantu Bil",
    "WoDeFaPiao": "Bil Saya",
    "FaPiaoXiangQing": "Butiran Bil",
    "KaiPiaoShiJian": "Masa Mencetak Bil",
    "DaiKaiFaPiao": "Bil Menunggu Dicetak",
    "DKFPJE": "Jumlah Bil Menunggu Dicetak",
    "KaiPiaoJinE": "Jumlah Bil",
    "GuanLianDanHao": "No. Dokumen Berkaitan",
    "ChuangJianShiJian": "Masa Penciptaan",
    "ZhiFuPingZheng": "Bukti Pembayaran",
    "QSRZQNR": "Sila masukkan kandungan yang betul",
    "QSRTDH_SPMC": "Sila masukkan no. borang pengembalian/nama produk",
    "ShangPinRuKu": "Produk Masuk Gudang",
    "TuiKuanChuLi": "Proses Refund",
    "YuanDingDanHao": "No. Pesanan Asal",
    "TuiHuoXinXi": "Maklumat Pengembalian",
    "TuiKuanXinXi": "Maklumat Refund",
    "TuiKuanZhuangTai": "Status Refund",
    "ZWTKJL": "Tiada Rekod Refund",
    "GDTKJL": "Lebih Banyak Rekod Refund",
    "DDDKFQRBJQSH": "Pesanan menunggu pengesahan harga CS, sila tunggu",
    "BNSRDYHDTSZF": "Tidak boleh masukkan aksara khas seperti petikan tunggal",
    "THSLBNWK": "Jumlah pengembalian tidak boleh kosong",
    "BZBNBHBQ": "Nota tidak boleh mengandungi emoji",
    "THSLBKDYKTHSL": "Jumlah pengembalian lebih daripada jumlah boleh pengembalian",
    "DDM_YZ_J": "Pesanan hadiah {number} produk apabila mencapai {target} yuan",
    "M_JZ_J": "Hadiah {number} produk apabila mencapai {target} produk",
    "M_JJZ_Y": "Penurunan kepada {money} yuan apabila mencapai {target} produk",
    "YDHJJZ_Y": "Harga pesanan asal diturunkan kepada {price} yuan",
    "M_JD_Z": "Penurunan {percent}% apabila mencapai {number} produk",
    "YDHJD_Z": "Harga pesanan asal diturunkan {percent}%",
    // Mercado Pago支付
    "WDSYT": "Kaunter Kas Saya",
    "ZZSYMPSMJY": "Sedang menggunakan transaksi scan Mercado Pago",
    "SKF": "Pihak Penerima",
    "SYSFK": "Scan untuk Bayar",
    "DDXQ": "Butiran Pesanan",
    "YUAN": "Yuan",
    // 优惠券
    "GXNHQ_Z_Y_": "Tahniah anda mendapat {num} helai {price} yuan {name}",
    "QBLX": "Semua Jenis",
    "QLQZX": "Pergi ke Pusat Terima Kupon",
    "YLYH": "Telah Terima Diskaun",
    "MZTJJKSY": "Boleh digunakan apabila memenuhi syarat",
    "GXNHD_Z_YHQ": "Tahniah anda mendapat {num} helai kupon",
    "G_Y": "Jumlah {price} yuan",
    "XZYHQ": "Pilih Kupon",
    "PLXD": "Pesanan Berkelompok",
    "FHJL": "Rekod Penghantaran",
    "DDTJ": "Statistik Pesanan",
    "DDGL": "Pengurusan Pesanan",
    "JKWFH": "Hanya Lihat Belum Dihantar",
    "DDS": "Jumlah Pesanan",
    "DGSPS": "Jumlah Produk Pesanan",
    "THSPS": "Jumlah Produk Pengembalian",
    "YFHSPS": "Jumlah Produk Telah Dihantar",
    "WFHSPS": "Jumlah Produk Belum Dihantar",
    "YFHSPJE": "Jumlah Wang Produk Telah Dihantar",
    "WFHSPJE": "Jumlah Wang Produk Belum Dihantar",
    "WFH": "Belum Dihantar",
    "YGJ": "Jangkaan",
    "GGBM": "Kod Spesifikasi",
    "SLHJ": "Jumlah Keseluruhan",
    "JEHJ": "Jumlah Wang Keseluruhan",
    "QPLKY": "Boleh Digunakan untuk Semua Kategori",
    "KYCXHDDJSY": "Boleh叠加 digunakan dengan aktiviti promosi",
    "BKDKYF": "Tidak Boleh Tolak Yuran Penghantaran",
    "SYHBYTH": "Tidak Dikembalikan Selepas Digunakan",
    "TiJi": "Isi Padu",
    "ZhongLiang": "Berat",
    "ZongTiJi": "Isi Padu Keseluruhan",
    "ZongZhongLiang": "Berat Keseluruhan",
    "QSRDHDCKDWLDHSJRSJH": "Sila masukkan no. pesanan/no. keluar gudang/no. resi logistik/penerima/nombor telefon",
    "CKDH": "No. Keluar Gudang",
    "WLDZT": "Status Resi Logistik",
    "WLDH": "No. Resi Logistik",
    "SJR": "Penerima",
};
export default ms_MY
